import { urlBase64ToUint8Array } from "common/utils/webPush";
import { showMessageModal } from "common/utils/modalController";
import { apiRequest } from "common/utils/api";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { t } from "i18next";

const PUSH_DENIED_NOTICE_KEY = "pushDeniedNoticeShown";
const PUSH_KEY_STORAGE = "webPushApplicationServerKey";

export async function subscribeWebPush(pushKey) {
  if (!pushKey) {
    console.warn("Web Push public key not found. Skip subscription.");
    return false;
  }

  // 브라우저 지원 체크
  if (!("serviceWorker" in navigator)) {
    showMessageModal(t("browserNotSupported", { ns: "webPush" }));
    return false;
  }

  if (!("PushManager" in window)) {
    showMessageModal(t("pushApiNotSupported", { ns: "webPush" }));
    return false;
  }

  if (!("Notification" in window)) {
    showMessageModal(t("notificationNotSupported", { ns: "webPush" }));
    return false;
  }
  // 알림 권한 요청
  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    const alreadyShown = localStorage.getItem(PUSH_DENIED_NOTICE_KEY);
    if (!alreadyShown) {
      showMessageModal(t("permissionDenied", { ns: "webPush" }));
      localStorage.setItem(PUSH_DENIED_NOTICE_KEY, "true");
    }
    return false;
  }

  const registration = await navigator.serviceWorker.ready;

  const oldSub = await registration.pushManager.getSubscription();
  const savedPushKey = localStorage.getItem(PUSH_KEY_STORAGE);

  /** ✅ pushKey가 변경된 경우 */
  if (oldSub && savedPushKey && savedPushKey !== pushKey) {
    console.info("🔄 Push key changed. Re-subscribing...");
    await oldSub.unsubscribe();
  }

  let subscription = await registration.pushManager.getSubscription();

  // Web Push 구독
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(pushKey),
    });
  }

  // 서버로 subscription 전달
  try {
    const res = await apiRequest({
      method: REQUEST_METHOD.POST,
      url: `/api/v1.0/web-push/subscribe`,
      body: { subscription },
    });

    if (res?.data?.code !== "0000") {
      showMessageModal(
        res?.data?.message || t("subscribeFailed", { ns: "webPush" }),
      );
      return false;
    }

    /** ✅ 성공 시 pushKey 저장 */
    localStorage.setItem(PUSH_KEY_STORAGE, pushKey);
  } catch (e) {
    console.error(e);
    showMessageModal(
      e?.response?.data?.message || t("subscribeError", { ns: "webPush" }),
    );
    return false;
  }

  return true;
}

export function clearWebPushStorage() {
  localStorage.removeItem(PUSH_KEY_STORAGE);
}
